import React from 'react'
import { Modal } from "../../../../common/modal";

export default function DeleteRuleModal({showModal, handleDeleteRule, handleCancel}) {
  return (
    <Modal
      title="Delete Pricing Rule"
      open={showModal}
      primaryButtonText="Delete"
      secondaryButtonText="Cancel"
      primaryClassName="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600 sm:col-start-2"
      onPrimary={handleDeleteRule}
      onSecondary={handleCancel}
      setOpen={handleCancel}
    >
      <p>Are you sure you want to delete it? It will be gone for good! This action cannot be undone.</p>
    </Modal>
  )
}
